module.exports = __webpack_public_path__ + "static/team2-85fce9443fd19595da4b28604381c939.png";